import { ReactNode } from 'react';
import { useDarkMode } from '../context/DarkModeContext';

type Props = {
  title: string;
  children: ReactNode;
  lastUpdated?: string;
  isPlaceholder?: boolean;
};

export function LegalPage({ title, children, lastUpdated, isPlaceholder = true }: Props) {
  const { darkMode } = useDarkMode();

  return (
    <div
      className={`min-h-screen ${
        darkMode ? 'bg-slate-900 text-slate-200' : 'bg-white text-slate-700'
      }`}
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <h1
          className={`text-3xl md:text-4xl font-bold mb-2 ${
            darkMode ? 'text-white' : 'text-slate-900'
          }`}
        >
          {title}
        </h1>
        {lastUpdated && (
          <p
            className={`text-sm mb-8 ${
              darkMode ? 'text-slate-500' : 'text-slate-400'
            }`}
          >
            Stand: {lastUpdated}
          </p>
        )}

        {isPlaceholder && (
          <div
            className={`mb-8 p-4 rounded-lg border text-sm ${
              darkMode
                ? 'bg-amber-900/20 border-amber-800 text-amber-300'
                : 'bg-amber-50 border-amber-200 text-amber-800'
            }`}
          >
            <strong>Platzhalter-Inhalt.</strong> Diese Seite enthaelt Struktur-Vorlagen, keine rechtssicheren Texte. Bitte mit Inhalten eines Generators (z.B. eRecht24, IT-Recht Kanzlei, datenschutz-generator.de) ersetzen.
          </div>
        )}

        <div
          className={`prose prose-slate max-w-none ${
            darkMode ? 'prose-invert' : ''
          } [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:mt-8 [&_h2]:mb-3 [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:mt-6 [&_h3]:mb-2 [&_p]:my-3 [&_p]:leading-relaxed [&_ul]:my-3 [&_ul]:pl-6 [&_ul]:list-disc [&_li]:my-1 [&_address]:not-italic ${
            darkMode
              ? '[&_h2]:text-white [&_h3]:text-white [&_strong]:text-white'
              : '[&_h2]:text-slate-900 [&_h3]:text-slate-900 [&_strong]:text-slate-900'
          }`}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
